import r from "../managers/braze-instance.js";
import W from "./content-cards-provider-factory.js";
export function subscribeToContentCardsUpdates(o) {
  if (!r.rr()) return;
  const t = W.m(),
    n = t.qt(o);
  if (!t.Ct()) {
    const o = r.rn();
    if (o) {
      const r = o.on(() => {
        t.bi(void 0, void 0, !0);
      });
      r && t.Tt(r);
    }
  }
  return n;
}
